import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const PERIOD_SHOW = "role/show";

export const showPeriod = createAsyncThunk(PERIOD_SHOW, async (thunkAPI) => {
  try {
    const dataSource = new DataSource({
      store: new ODataStore({
        url: `${baseUrl}Period`,
        key: "Oid",
        version: 4,
        beforeSend: (request) => {
          request.headers["token"] = token;
        },
      }),
    });
    return dataSource;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});
